export enum UnionFlowRouteEnum {
  DEFAULT = "default",
  MEMBER = "member",
  CONSENT = "consent",
  CONFIRM = "confirm",
  RECEIPT = "receipt",
}
